import {
  AdminUsersResponseType,
  ApiClient,
  ApiErrorMessage,
  CategoryResponseType,
  MailingListResponseType,
  PhrasesResponseType,
  SettingsResponseType,
  SignagesResponseType,
  TrainGroupsResponseType,
  TrainsResponseType
} from './ApiClient';

export const QueryAdminUsersApi = async (
  tag: string
): Promise<AdminUsersResponseType> => {
  try {
    const response = await ApiClient.get('/admin/admin_users' + tag, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const QueryTrainsApi = async (
  tag: string
): Promise<TrainsResponseType> => {
  try {
    const response = await ApiClient.get('/admin/trains' + tag, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const QueryTrainGroupsApi = async (
  tag: string
): Promise<TrainGroupsResponseType> => {
  try {
    const response = await ApiClient.get('/admin/train_groups' + tag, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const QueryCategoryApi = async (
  tag: string
): Promise<CategoryResponseType> => {
  try {
    const response = await ApiClient.get('/admin/categories' + tag, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};
export const QueryPhrasesApi = async (
  tag: string
): Promise<PhrasesResponseType> => {
  try {
    const response = await ApiClient.get('/admin/phrases' + tag, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const QueryMailingListApi = async (
  tag: string
): Promise<MailingListResponseType> => {
  try {
    const response = await ApiClient.get('/admin/mailinglists' + tag, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const QuerySignagesApi = async (
  tag: string
): Promise<SignagesResponseType> => {
  try {
    const response = await ApiClient.get('/admin/signages' + tag, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const QuerySettingsApi = async (
  tag: string
): Promise<SettingsResponseType> => {
  try {
    const response = await ApiClient.get('/admin/settings' + tag, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};
